import React from 'react';
import Button from '@atlaskit/button';
import EmptyState from '@atlaskit/empty-state';
import { Box, xcss } from '@atlaskit/primitives';
import { Stack, Text } from '@atlaskit/primitives/compiled';
import { expVal } from '@atlassian/jira-feature-experiments';
import SearchNoResultsImage from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/empty/components/search-no-results/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import { fg } from '@atlassian/jira-feature-gating';
import messages from './messages.tsx';

const ANOTHER_FILTER_LINK = '/jira/filters';

export const NoFilter = ({ reason }: { reason?: string }) => {
	const { formatMessage } = useIntl();

	return (
		<ContextualAnalyticsData sourceName="noFilter" sourceType={SCREEN}>
			<FireScreenAnalytics
				attributes={
					reason
						? {
								reason,
							}
						: undefined
				}
			/>
			<EmptyState
				header={formatMessage(messages.weCouldntFindThisFilter)}
				description={
					fg('jfp-magma-hydration-no-filter') ? (
						<Stack as="span" space="space.150">
							<Text as="span">{formatMessage(messages.filterNoExistOrNoPermissions)}</Text>
							<Text as="span">
								{formatMessage(
									expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
										? messages.tryAnotherFilterIssueTermRefresh
										: messages.tryAnotherFilter,
								)}
							</Text>
						</Stack>
					) : (
						<>
							{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
							<p>{formatMessage(messages.filterNoExistOrNoPermissions)}</p>
							{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
							<p>
								{formatMessage(
									expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
										? messages.tryAnotherFilterIssueTermRefresh
										: messages.tryAnotherFilter,
								)}
							</p>
						</>
					)
				}
				secondaryAction={
					<Button href={ANOTHER_FILTER_LINK}>{formatMessage(messages.viewFilters)}</Button>
				}
				primaryAction={
					// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
					<Button appearance="primary" href={window.location.pathname}>
						{formatMessage(
							expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
								? messages.searchIssuesIssueTermRefresh
								: messages.searchIssues,
						)}
					</Button>
				}
				renderImage={() => (
					<Box xcss={ImageWrapperStyles}>
						<SearchNoResultsImage alt="" />
					</Box>
				)}
			/>
		</ContextualAnalyticsData>
	);
};

export default NoFilter;

const ImageWrapperStyles = xcss({
	maxHeight: '165px',
	maxWidth: '150px',
	margin: 'auto',
	marginBottom: 'space.300',
});
